import configData from "../common/configData.json";
const isNewRelicEnabled = configData?.newRelic?.isNewRelicEnabled;

const isNewRelicAvailable = () => {
  return typeof window !== 'undefined' && window.newrelic;
};

const formatPayload = (message, meta = {}) => {
  return {
    message,
    ...meta,
    timestamp: new Date().toISOString()
  };
};

//In case of errors
export const logNewRelicError = (response, customTitle) => {
    if (isNewRelicAvailable() && isNewRelicEnabled) {
        const countryCode = localStorage.getItem("countryCode");
        const userID = localStorage.getItem("email");

        let errorTitle = customTitle || (response?.errors?.errorMessage ? response?.statusCode + " " +  response?.errors?.errorMessage : response?.statusCode)
        window.newrelic.noticeError(new Error(errorTitle), {
            "user.sessionemail": userID,
            "user.market": countryCode,
            "error.details": JSON.stringify(response)
        });
    }
};

//Setting User ID in New Relic at the time of login
export const setNewRelicSessionUserID = (email) => {
    if (isNewRelicAvailable() && isNewRelicEnabled) {
        window.newrelic.setUserId(email);
    }
};

//In case of informational messages
export const logNewRelicInfo = (message, meta) => {
  if (isNewRelicAvailable() && isNewRelicEnabled) {
    window.newrelic.log(message, {
      level: 'info',
      customAttributes: meta
    });
  }
};

// In case of warnings
export const logNewRelicWarn = (message, meta) => {
  if (isNewRelicAvailable() && isNewRelicEnabled) {
    window.newrelic.log(message, {
      level: 'warn',
      customAttributes: meta
    });
  }
};

